export const mauritiusText = {
  mainText:
    "We explained above why we chose Mauritius as our production place. But we do not want to hide these five other convincing arguments ;)",
  firstText:
    "The obvious one: Quite awesome to do laptop work when you have LTE at every beach and such a view.",
  secondText:
    "The Mauritian people are just amazing. Wearing a cap when it is over 30 degrees or sun glasses in dark market halls... But most important: we experienced an amazing varity of cultures, great kindness and helpfulness.",
  thirdText:
    "We like the funny icecream trucks at the beaches. Even though it is a bit creepy when the truck and you are alone at the beach and it constantly is playing this childrens melody from an old music box.",
  forthText:
    "Mauritius has awesome street artists. We are proud that some of the best street artists of the island are working with us together to come up with unique print designs for our customers to choose from.",
  fifthText:
    "The fauna is amazing. Dogs running around on the roof, snails bigger than cigarette boxes. The only thing about the animal size:  when the spiders in the bedroom are bigger than this snail. But even this we learned to wish for, since it is better than a scorpion on a kitchen table."
};



// WEBPACK FOOTER //
// ./src/components/Pages/Progress/Content/texts.js